<template>
  <div class="container">
    <div class="bs-docs-section">
      <div class="row">
        <div class="col-md-12 mt-5">
          <h2 class="mb-3">My Movie DB</h2>

          <div>
            My Movie DB serves as a virtual library for organizing the movies you plan to watch and
            those you've already seen.
            <br>
            You can also share reviews with other users on the My Movie DB platform.<br><br>
          </div>

          <div>
            <strong>Here's a more concise and clear way to express the process:</strong><br><br>
          </div>

          <ol>
            <li>Begin by searching for a movie using the search function.</li>
            <li>
              Once you find a movie, add it to your "My Watch List." Here, you can access movie
              details and ratings.
              <br>
              If you decide not to watch the movie, you can remove it from your list.
            </li>
            <li>
              Watch the movie and then save it to "My Watched List." If you wish, you can write a
              review,
              <br>
              and it will be stored in your "My Watched List" for future reference.
            </li>
          </ol>

          <div>
            <strong>How to sign up and log in:</strong>
            <br>
            If you want to benefit from the functionality of the site, it's best to log in after signing up.<br>
            You can create an account using your email and password, or you can use the provided account for quick access!<br>
<br>
            <strong>This is the provided account:</strong>
<br>
            User: johan@hedman.de<br>
            PWD: 123456<br>
            <br>
            For more information, please visit the <a href="/about" target="_self">About</a> page!<br>
            <br>
            <strong>This is just a demo project to showcase the use of Vue.js for the frontend and Laravel for the backend.</strong><br>
            <br>
            <br>
            <br>
            <br>
            <br>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.padding-left {
  padding-left: 12px;
}
.margin-left {
  margin-left: 18px;
}
a {
  color: #008cba;
  text-decoration: none;
}
</style>

